const styles = {
  buttonSx: {
    borderRadius: 0,
    borderColor: "rgba(255,255,255,0.45)",
    color: "white",
    fontWeight: 600,
    letterSpacing: "0.12em",
    whiteSpace: "nowrap",
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: "white",
      borderColor: "white",
      color: "black",
    },
  },
};

export default styles;
